<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card>
            <v-card-title class="justify-center">Agent scale change</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row dense>
                    <v-col cols=2 class="font-weight-bold">Agent</v-col> 
                    <v-col cols=3>{{ scale.agent_name }}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=2 class="font-weight-bold">Acco</v-col> 
                    <v-col cols=3>{{ scale.acco }}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=2 class="font-weight-bold">Period</v-col> 
                    <v-col cols=7>{{ scale.year }}</v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=2 class="font-weight-bold">Scale</v-col> 
                    <v-col cols=1>1</v-col> 
                    <v-col cols=1>2</v-col> 
                    <v-col cols=1>3</v-col> 
                    <v-col cols=1>4</v-col> 
                    <v-col cols=1>5</v-col> 
                    <v-col cols=6></v-col> 
                </v-row>
                <v-row dense>
                    <v-col cols=2 class="font-weight-bold">Perc. (contract)</v-col> 
                    <v-col cols=1>{{ scale.scale1 }}</v-col> 
                    <v-col cols=1>{{ scale.scale2 }}</v-col> 
                    <v-col cols=1>{{ scale.scale3 }}</v-col> 
                    <v-col cols=1>{{ scale.scale4 }}</v-col> 
                    <v-col cols=1>{{ scale.scale5 }}</v-col> 
                    <v-col cols=6></v-col> 
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-row dense class="pt-2">
                    <v-col cols=12 class="font-weight-bold text-center">Set new values</v-col> 
                </v-row>   
                                
                <v-row dense >
                    <v-col cols=2 class="font-weight-bold pt-4">Scale</v-col> 
                    <v-col cols=2 >
                        <v-select v-model="scale.scale" :items="scale.scale_keuzes" item-value="nr" item-text="desc" dense></v-select>
                    </v-col> 
                    <v-col cols=8 class="pt-4 pl-4">
                        (Change the percentage manually!)
                    </v-col> 
                </v-row>                   
                <v-row dense>
                    <v-col cols=2 class="font-weight-bold pt-4">Percentage</v-col> 
                    <v-col cols=2 >
                        <v-select v-model="scale.perc" :items="scale.scale_perc_keuzes" item-value="nr" item-text="desc" dense></v-select>
                    </v-col> 
                </v-row>    
                <v-row dense>
                    <v-col cols=12 class="pt-4">
                        Changing scale only will influence next years scale.<br>
                        Changing the percentage will change this years commission. 
                    </v-col> 
                </v-row>                 
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="warning" small @click="saveScale">Save</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="dialog=false">Close</v-btn>
            </v-card-actions>
        </v-card> 
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                dialog: false,
                scale: {
                    agent_name: "",
                    year: 9999,
                },
                hscj_encrid: "",
            }
        },
        methods: { 
            openDialog(agent_encrid, hscj_encrid) {
                this.dialog = false;
                this.hscj_encrid = hscj_encrid;
                this.getAgentScaleEdit(agent_encrid, hscj_encrid);
            },
            getAgentScaleEdit(agent_encrid, hscj_encrid) {
                this.$axios.post("ares/json/ares/syst/agent/ovrz/getAgentScaleEdit.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAgentScaleEdit",
                    },
                    getAgentScaleEdit: {
                        agent_encrid: agent_encrid,
                        hscj_encrid: hscj_encrid
                    },
                }).then((res) => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.scale = res.data.getAgentScaleEdit;
                        this.dialog = true;
                    }
                });

            },
            saveScale() {
                this.$axios.post("ares/json/ares/syst/agent/ovrz/saveAgentScale.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveAgentScale",
                    },
                    saveAgentScale: {
                        hscj_encrid: this.hscj_encrid,
                        scale: this.scale.scale,
                        perc: this.scale.perc,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveAgentScale.tekst,
                            color: res.data.saveAgentScale.kleur,
                        });
                        this.$emit("getAgentScaleOverview");
                        this.dialog = false;
                    }
                });
            },
        }
    }
</script>

